import * as ReactDOM from 'react-dom/client';

import App from './expert/App.js';

import './expert.css';
import '../modal/modal.css';

const root = ReactDOM.createRoot(document.getElementById('search-expert-form'));
root.render(<App />);
